var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.loading}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"block flex_center_center"},[_c('van-loading',{attrs:{"color":"#1ac388"}})],1)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }